import 'whatwg-fetch';

export default fetch;
